<template>
  <el-tabs
      id="scheduleTabPanel"
      v-model="activeName">
    <el-tab-pane
        label="Active"
        name="active">
      <schedules-table
          :table-data="activeData"
          :device-name="deviceName"
          empty-message="There are no active schedules." />
    </el-tab-pane>
    <!--    <el-tab-pane-->
    <!--        label="Inactive"-->
    <!--        name="inactive">-->
    <!--      <schedules-table-->
    <!--          :table-data="inactiveData"-->
    <!--          :device-name="deviceName"-->
    <!--          empty-message="There are no inactive schedules." />-->
    <!--    </el-tab-pane>-->
  </el-tabs>
</template>

<script>
import SchedulesTable from "./ScuedulesTable";
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
import { isEmpty, get, capitalize, times } from "lodash";
const { mapGetters } = createNamespacedHelpers("db/device");
const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");
import TimeZoneFormatter from "@/helpers/TimeZoneFormatterHelper";

export default {
  name: "SchedulesTabs",
  components: { SchedulesTable },
  props: {
    deviceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeName: "active",
      inactiveData: [],
      activeData: [],
    };
  },
  computed: {
    ...mapGetters(["doorbotId"]),
    ...accountGetters(["accountVerified"]),
  },
  created() {
    if (this.accountVerified) {
      this.fetchDataFromBackend();
    } else {
      this.initializeHashedData();
    }
  },
  methods: {
    initializeHashedData() {
      times(6, (i) => {
        this.activeData.push({
          name: {
            business: "********",
            person: "********",
          },
          frequency: {
            range: "********",
            days: ["*", "*", "*", "*", "*", "*"],
          },
          accessPeriod: {
            range: "*********",
          },
        });

        this.inactiveData.push({
          name: {
            business: "********",
            person: "********",
          },
          frequency: {
            range: "********",
            days: ["*", "*", "*", "*", "*", "*"],
          },
          accessPeriod: {
            range: "*********",
            expiredOn: "*******",
          },
        });
      });
    },
    fetchDataFromBackend() {
      let path = `v3/devices/${this.doorbotId}/schedules`;
      axios
        .get(path)
        .then((response) => {
          const mappedData = this.mapToTableInfo(response.data);
          this.activeData = mappedData.filter(
            (schedule) => !schedule.isInactive
          );
          this.inactiveData = mappedData.filter(
            (schedule) => schedule.isInactive
          );
        })
        .catch((error) => {
          console.log(
            `Error for: ${path}: ${JSON.stringify(path)}: ${JSON.stringify(
              error
            )}`
          );
        });
    },
    mapToTableInfo(data) {
      let dateFormatter = (dateTime) => {
        if (isEmpty(dateTime)) {
          return dateTime;
        }
        return TimeZoneFormatter.formattedTime(dateTime).slice(0, -9);
      };

      const getTimeRange = (startTime, endTime) => {
        const twentyFourHoursToTwelveFormatter = (time) => {
          if (isEmpty(time)) {
            return time;
          }

          let timeTokens = time.split(":");

          return new Date(
            1776,
            6,
            4,
            timeTokens[0],
            timeTokens[1],
            timeTokens[2]
          )
            .toLocaleString([], { hour12: true })
            .split(",")[1];
        };

        if (isEmpty(startTime)) {
          return "";
        }

        if (isEmpty(endTime)) {
          return startTime;
        }

        startTime = twentyFourHoursToTwelveFormatter(startTime);
        endTime = twentyFourHoursToTwelveFormatter(endTime);

        return `${startTime} - ${endTime}`;
      };

      const getDateRange = (startDate, endDate) => {
        const NO_START_DATE = "No start date";
        const NO_END_DATE = "No end date";

        if (isEmpty(startDate)) {
          startDate = NO_START_DATE;
        }

        if (isEmpty(endDate)) {
          endDate = NO_END_DATE;
        }

        if (startDate !== NO_START_DATE) {
          startDate = dateFormatter(startDate);
        }

        if (endDate !== NO_END_DATE) {
          endDate = dateFormatter(endDate);
        }

        return `${startDate} - ${endDate}`;
      };

      let schedules = data || [];
      return schedules.map((schedule) => {
        return {
          name: {
            business: get(schedule, "name", undefined),
            person: `${get(schedule, "shared_user.first_name", "")} ${get(
              schedule,
              "shared_user.last_name",
              ""
            )}`,
          },
          frequency: {
            range: getTimeRange(
              get(schedule, "start_time", undefined),
              get(schedule, "end_time", undefined)
            ),
            days: get(schedule, "weekdays", []).map((weekday) =>
              capitalize(weekday)
            ),
          },
          accessPeriod: {
            range: getDateRange(
              get(schedule, "start_date", undefined),
              get(schedule, "end_date", undefined)
            ),
            creationDate: dateFormatter(get(schedule, "created_at", undefined)),
            expiredOn: dateFormatter(get(schedule, "expired_at", undefined)),
            deletedOn: dateFormatter(get(schedule, "deleted_at", undefined)),
          },
          isInactive:
            get(schedule, "expired_at", undefined) ||
            get(schedule, "deleted_at", undefined),
        };
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/newui/tabs.scss";

#scheduleTabPanel .el-tabs__header {
  @include tab__header();
}

#scheduleTabPanel .el-tabs__nav-wrap::after {
  @include tab__bottom-border();
}

#scheduleTabPanel .el-tabs__item {
  @include tab__title_active();
}

#scheduleTabPanel .el-tabs__item:not(.is-active) {
  @include tab__title_inactive();
}
</style>
